export const sceneNumbers = {
	initMainMenu: 0,
	initIntroduction: 1,
	tema5SubtopicOne: 2,
	tema5SubtopicTwo: 3,
	tema5SubtopicThree: 4,
	tema5SubtopicFour: 5,
};
